import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface addEmployeeFields {
    name?: string;
    serial_no?: string;
    mobile?: string;
    job?: string;
    salary?: number;
    working_status?: 'Working' | 'Pending' | "Suspended"
}

// Add employee state
export interface addEmployeeState {
    fields: addEmployeeFields,
    editId: number,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialAddEmployeeState: addEmployeeState = {
    fields: {
        name: "",
        serial_no: "",
        mobile: "",
        job: "",
        salary: 0
    },
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add employee slice
export const addEmployeeSlice = createSlice({
    name: 'add_employee',
    initialState: initialAddEmployeeState,
    reducers: {
        init: state => initialAddEmployeeState,
        set: ( state, {payload}: PayloadAction<addEmployeeFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})